import React from 'react';
import { Card, CardContent, Skeleton } from '@cargomatic/ui';
export default function StatCard({ label, className = '', isLoading = false, children, }) {
    return (React.createElement(Card, { className: `border flex-shrink-0 min-w-[160px] ${className}` },
        React.createElement(CardContent, { className: "pt-2 pb-1.5 px-3" },
            React.createElement("div", { className: "text-xs text-muted-foreground font-medium mb-0.5" }, isLoading ? React.createElement(Skeleton, { className: "h-3 w-20" }) : label),
            React.createElement("div", { className: "text-base font-bold" }, isLoading ? React.createElement(Skeleton, { className: "h-5 w-24" }) : children))));
}
